import TGLabSettings from '@/modules/integrations/types/tglab/TGLabSettings'
import TGLabOverview from '@/modules/integrations/types/tglab/TGLabOverview'
import TGLabPromotions from '@/modules/integrations/types/tglab/TGLabPromotions'
import TGLabSyncDialog from '@/modules/integrations/types/tglab/TGLabSyncDialog'

export default Object.freeze({
  type: 'tglab',
  title: 'Integrations_TGLab',
  category: 'Integrations_TGLab_Category',
  description: 'Integrations_TGLab_Description',
  image: require('@/img/integrations/tglab.png'),
  requiresAdmin: false,
  components: {
    settings: TGLabSettings,
    overview: TGLabOverview,
    promotions: TGLabPromotions
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_TGLab_Action_Sync',
      dialog: TGLabSyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/tg-lab'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/tglab/index.js